import name from './name'

const selectSliceData = state => state[name]

const selectTrialBannerDismissed = state =>
  selectSliceData(state)?.trialBannerDismissed || false

export { selectTrialBannerDismissed }
